import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ChevronUpSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.975 6.899a1.514 1.514 0 012.049 0l8.506 7.862c.627.58.627 1.557 0 2.136l-.222.205a1.514 1.514 0 01-2.048 0l-6.919-6.397a.505.505 0 00-.683 0L4.74 17.1a1.514 1.514 0 01-2.048 0l-.221-.204a1.448 1.448 0 010-2.135l8.505-7.863z", fill: "currentColor" })] })));
};

export { ChevronUpSolidIcon };
//# sourceMappingURL=ChevronUpSolidIcon.js.map
